import _             from 'underscore';
import classNames    from 'classnames';
import React, { FC } from 'react';
import { Header }    from 'semantic-ui-react';
import { FlexItem }  from './FlexItem';
import { Flexbox }   from './Flexbox';

import { ClassValue }                                                                          from 'classnames/types';
import { Align, AlignVertical, BorderClassSize, CorvalColor, CorvalColorTheme, CorvalUIColor } from '../../types/componentPropTypes';
import { FlexAlign, FlexFlow, FlexJustify, MarginSize, NumberRange0to100, PaddingSize, Size }  from '../../types/componentPropTypes';

export interface TitledRailContainerProps {
	labelElement?: any,
	labelAlign?: Align | AlignVertical,
	labelContent?: any,
	labelReadsUpwards?: boolean,
	
	railSize?: NumberRange0to100,
	railPaddingVertical?: PaddingSize,
	railPaddingHorizontal?: PaddingSize,
	railPosition?: Align,
	railMarginSize?: Omit<MarginSize, Size.XL>,
	railColor?: CorvalColor,
	railTheme?: CorvalColorTheme,
	railBorderColor?: CorvalColor,
	railBorderSize?: BorderClassSize,
	
	className?: ClassValue,
	childContainerClasses?: ClassValue,
}

const defaultProps: TitledRailContainerProps = {
	labelElement:      'h4',
	labelAlign:        Align.CENTER,
	labelContent:      null,
	labelReadsUpwards: true,
	
	railSize:              5,
	railPaddingVertical:   Size.SM,
	railPaddingHorizontal: Size.XS,
	railPosition:          Align.LEFT,
	railMarginSize:        Size.SM,
	railColor:             CorvalUIColor.FEATHER,
	railTheme:             null,
	railBorderColor:       null,
	railBorderSize:        null,
	
	className:             null,
	childContainerClasses: null,
}

const TitledRailContainer: FC<TitledRailContainerProps> = ( props ) => {
	
	let marginPosition = ( props.railPosition === Align.RIGHT ) ? Align.LEFT : Align.RIGHT,
	    railOnRight    = ( props.railPosition === Align.RIGHT ),
	    railSizes      = [ Size.XS, Size.SM, Size.MD, Size.LG ],
	    railPaddingMap = _.object( railSizes, [ 5, 10, 20, 30 ] );
	
	return (
		<Flexbox align={ FlexAlign.STRETCH }
		         justify={ FlexJustify.START }
		         direction={ railOnRight ? FlexFlow.ROW_REVERSE : null }
		         className={ classNames( 'margin-md-bottom', props.className ) }>
			
			<FlexItem noGrow
			          basis={ props.railSize }
			          className={ classNames( {
				          'position--relative':                                       true,
				          [ `container--themed-${ props.railTheme }` ]:               ( _.isString( props.railTheme ) ),
				          [ `container--colored-bg-${ props.railColor }` ]:           ( _.isString( props.railColor ) && _.isNull( props.railTheme ) ),
				          [ `border--${ props.railBorderSize }` ]:                    ( _.isString( props.railBorderSize ) ),
				          [ `border--colored-${ props.railBorderColor }` ]:           ( _.isString( props.railBorderColor ) ),
				          [ `margin-${ props.railMarginSize }-${ marginPosition }` ]: _.contains( railSizes, props.railMarginSize )
			          } ) }>
				
				<Flexbox align={ FlexAlign.CENTER }
				         justify={ FlexJustify.CENTER }
				         className={ classNames( 'max-height' ) }>
					
					<Header as={ props.labelElement }
					        style={ {
						        writingMode:     'vertical-rl',
						        textOrientation: 'mixed',
						        top:             _.contains( _.keys( railPaddingMap ), props.railPaddingVertical ) ? railPaddingMap[ props.railPaddingVertical ] : 0,
						        bottom:          _.contains( _.keys( railPaddingMap ), props.railPaddingHorizontal ) ? railPaddingMap[ props.railPaddingHorizontal ] : 0
					        } }
					        className={ classNames( [
						        'position--absolute',
					        ], {
						        'rotate--180':                    props.labelReadsUpwards,
						        [ `text-${ props.labelAlign }` ]: _.contains( [ Align.LEFT, Align.CENTER, Align.RIGHT ], props.labelAlign ),
						        [ `text-right` ]:                 _.contains( [ AlignVertical.TOP ], props.labelAlign ),
						        [ `text-left` ]:                  _.contains( [ AlignVertical.BOTTOM ], props.labelAlign ),
					        } ) }
					        content={ props.labelContent }/>
				
				</Flexbox>
			
			</FlexItem>
			<FlexItem
				basis={ 50 }
				className={ classNames( 'flexbox', props.childContainerClasses ) }>
				
				{ props.children }
			
			</FlexItem>
		</Flexbox>
	);
};

TitledRailContainer.defaultProps = defaultProps;

export { TitledRailContainer }
